module.exports = __webpack_public_path__ + "static/media/PurpuraPng.0b5bfbb4.png";